import { useQuery } from '@tanstack/react-query'
import { filterCowsWithFarmCowNumber } from 'components/cattles/cattlesPage/shared/cattleListFilters'
import { IFiltersLamenessTable } from 'models'
import CattlesApiService from 'services/cattlesApiServices'

const PAGE_SIZE = 100

const resolveGroupId = (activeFilter?: number | string) =>
	activeFilter === 'all' || !activeFilter ? null : Number(activeFilter)

interface UseVisibleCowsCountOptions {
	activeFilter?: number | string
	fatnessPoint?: number[]
	params?: IFiltersLamenessTable
	tag_id_search?: string
	identified?: boolean
	ordering?: string | null
	enabled?: boolean
}

const countVisibleCows = async (options: {
	groupId: number | null
	fatnessPoint?: number[]
	params?: IFiltersLamenessTable
	tag_id_search?: string
	identified?: boolean
	ordering?: string | null
}) => {
	const { groupId, fatnessPoint, params, tag_id_search, identified, ordering } =
		options

	let page = 1
	let visibleCount = 0
	let totalFromApi = 0
	let hasMorePages = true

	while (hasMorePages) {
		const response = await CattlesApiService.getCowsList(
			groupId,
			fatnessPoint,
			page,
			PAGE_SIZE,
			params,
			tag_id_search,
			identified,
			ordering,
		)
		totalFromApi = response.data.count ?? 0
		visibleCount += filterCowsWithFarmCowNumber(response.data.results).length

		hasMorePages =
			response.data.results.length > 0 && page * PAGE_SIZE < totalFromApi
		page += 1
	}

	return visibleCount
}

export const useVisibleCowsCount = (options: UseVisibleCowsCountOptions) => {
	const {
		activeFilter,
		fatnessPoint,
		params,
		tag_id_search,
		identified,
		ordering,
		enabled = true,
	} = options
	const groupId = resolveGroupId(activeFilter)

	return useQuery({
		queryKey: [
			'visibleCowsCount',
			groupId,
			fatnessPoint,
			params,
			tag_id_search,
			identified,
			ordering,
		],
		queryFn: () =>
			countVisibleCows({
				groupId,
				fatnessPoint,
				params,
				tag_id_search,
				identified,
				ordering,
			}),
		enabled,
		staleTime: 50000,
	})
}
